import React, { Component } from 'react';
import payment              from '../../lib/jquery.payment';
import Parse                from 'parse';
import Api                  from '../../Utils/api';
import Spinner              from '../generic/spinner';
import classNames           from 'classnames/bind';
import TabContainer         from '../generic/tab-container';
import TabPane              from '../generic/tab-pane';
import AddCreditCard        from '../payment/add-credit-card';
import AddBankAccount       from '../payment/add-bank-account';
import AcctCreation         from '../acct-creation';

export default class RegisterPaymentMethod extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPaymentMethodAdded : null,
            showSpinner          : false,
            activeLocation : null
        };
    }

    componentWillMount() {
        this.setState({
            activeLocation : this.props.activeLocation
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != null) {
            this.setState({
                activeLocation : nextProps.activeLocation,
                showSpinner    : true
            },
            () => {
                this.checkIfLocationHasCusId(nextProps.activeLocation);
            });
        }
    }

    checkIfLocationHasCusId = (activeLocation) => {

        if (!activeLocation) {
            return;
        }

        if (activeLocation["cus_id"]) {
            this.updatePaymentMethodStatus();
        } else {

            const locId = activeLocation.objectId;

            let currentUser = Parse.User.current();
            let userId = currentUser.id;
            let sessionToken = currentUser.getSessionToken();

            Api.getLocationDetail(locId, userId, sessionToken)
                .then(
                    (result) => {
                        const locationDetail = result.data;
                        const customerId = locationDetail["cus_id"];

                        if(customerId) {
                            this.updatePaymentMethodStatus();
                        } else {
                            this.setState({
                                locIdBeingProcessed  : locationDetail.objectId,
                                isPaymentMethodAdded : false
                            });
                        }

                        return this.saveCustomerTempData(locationDetail.objectId);
                    },
                    (error) => {
                        console.log("Error occured while fetching latest location data!");
                    }
                ).then(() => {
                    console.log("saveCustomerTempData data!");
                }).fail((error) => {
                    console.log("saveCustomerTempData data!"+JSON.stringify(error));
                });

        }

    }

    componentDidMount () {

        let currentUser = Parse.User.current();

        if (currentUser) {
            const businessDetail = currentUser.get("bizId");
            const locPtr         = currentUser.get("locationDetailPointer");
            const bizId          = businessDetail.id;
            const userId         = currentUser.id;
            const sessionToken   = Parse.User.current().getSessionToken();
            const data           = {};

            if (businessDetail) {

                this.setState({
                    showSpinner : true
                });

                if(this.props.activeLocation) {
                    this.checkIfLocationHasCusId(this.props.activeLocation);
                } else {

                    let call = Api.getBusinessDetail(bizId);

                    call.then((res) => {
                        const businessDetail = res.data;
                        data.businessDetail = businessDetail;
                    })
                    .then(() => {
                        return Api.getLocationsForBizId(bizId)
                    })
                    .then((response)=> {
                        // console.log("Data:"+JSON.stringify(response));
                        let locationDetails = response.data;
                        if (locPtr) {
                            locationDetails
                            = locationDetails
                                .filter((fetchedLocation) => locPtr.id === fetchedLocation.objectId);
                        }
                        // console.log(JSON.stringify(locationDetails));
                        data.locationDetails = locationDetails;
                        return data;
                    }).then((data) => {
                        const firstLocation = data.locationDetails[0];
                        this.setState({
                            showSpinner : false,
                            activeLocation : firstLocation
                        });
                        return this.checkIfLocationHasCusId(firstLocation);
                    }, (error) => {
                        console.log(JSON.stringify(error));
                        this.setState({showSpinner : false});
                    }).fail((error) => {
                        console.log("error"+JSON.stringify(error));
                        this.setState({showSpinner : false});
                    });
                }
            }
        }
    }

    saveCustomerTempData = (locIdGenerated) => {
        let currentUser = Parse.User.current();
        let userId      = currentUser.id;
        let locId       = locIdGenerated;
        return Api.saveCustomerTempData(userId, locId).fail(
            (error) => {
                console.log("error"+JSON.stringify(error));
                this.setState({ showSpinner : false });
            });
    }

    updatePaymentMethodStatus = () => {

        this.setState({
            isPaymentMethodAdded : true,
            showSpinner          : false
        });

    }

    render() {
        let registerPaymentMethodComp = (
            <div className="container">
                <div className="row register-payment-method">
                    <br/>
                    <h3 className="text-center">Enter billing information</h3>
                    <br/>
                    <TabContainer selected={0} classNames="tab-container">

                        <TabPane label="Add Card Details" classNames="add-card-details-tab">
                            <AddCreditCard
                                locId          = {this.state.locIdBeingProcessed}
                                callbackParent = {this.updatePaymentMethodStatus}
                            />
                        </TabPane>

                        <TabPane label="Add Bank Details" classNames="add-bank-details-tab">
                            <AddBankAccount
                                locId          = {this.state.locIdBeingProcessed}
                                callbackParent = {this.updatePaymentMethodStatus}
                            />
                        </TabPane>
                    </TabContainer>
                </div>
            </div>
        );

        if (this.state.isPaymentMethodAdded === null) {
            return ( <div /> );
        }

        return  this.state.isPaymentMethodAdded ? <AcctCreation showSpinner={this.state.showSpinner} activeLocation={this.state.activeLocation} /> : registerPaymentMethodComp;
    }
}



// WEBPACK FOOTER //
// src/components/register/RegisterPaymentMethod.js